<template>
  <div>
    <button v-on:click="kartDetay()" style="border: none; background: none">
      <box-icon style="float: right" name="search-alt-2" animation="tada-hover" color="#7367F0"
        class="text-body align-middle mr-25"></box-icon>
    </button>
    <vs-popup type="filled" pazaryer title="Detay" :active.sync="popupKartDetay">
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-row>
              <b-col>
                <vs-button @click="yazdir()" class="mb-base mr-3" type="border" icon-pack="feather"
                  icon="icon icon-download">İndir/Yazdır</vs-button>
              </b-col>
            </b-row>
            <div id="printMe2">
              <b-container class="bv-example-row">
                <b-row>
                  <b-col lg="8">
                    <b-container class="bv-example-row">
                      <b-row style="border-radius: 0.25rem">
                        <b-col style="
                            background-color: rgba(0, 207, 232, 0.12);
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          " lg="3">Cari Adı
                        </b-col>
                        <b-col p-3 style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          " lg="9">{{ ACTNAME }}</b-col>
                      </b-row>

                      <b-row>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Tarih</b-col>
                        <b-col lg="4" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ parseDate(TRANSDATE) }}</b-col>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Vade</b-col>
                        <b-col lg="2" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ parseDate(DUEDATE) }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Fatura No</b-col>
                        <b-col lg="4" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ RECEIPTNO }}</b-col>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Vade Gün</b-col>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ DUEDAY }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Bayi İsk.Or.</b-col>
                        <b-col lg="4" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">2 of 3</b-col>
                        <b-col lg="3" style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Peşin İsk.Or</b-col>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">3 of 3</b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                  <b-col lg="4">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col style="
                            background-color: rgba(0, 207, 232, 0.12);
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">Ürün Toplamı</b-col>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ PRODUCTSUM }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">KDV Toplamı</b-col>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ VATSUM }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                            background-color: rgba(0, 207, 232, 0.12);
                          ">Genel Toplam</b-col>
                        <b-col style="
                            border: 1px solid rgba(0, 0, 0, 0.125);
                            padding: 10px;
                            border-radius: 0.25rem;
                          ">{{ TOTAL }}</b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </b-container>
              <b-row style="margin-top: 25px">
                <vx-card id="invoice-container" style="padding: 25px">
                  <!-- INVOICE METADATA -->

                  <br />
                  <table style="border-top: 1px solid grey; width: 100%" class="border-collapse">
                    <tr>
                      <td>
                        <table style="width: 100% !important; text-align: center">
                          <tr>
                            <th style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              ">
                              BARKOD
                            </th>
                            <th style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              ">
                              ÜRÜN ADI
                            </th>
                            <th style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              ">
                              ÜRÜN FİYATI
                            </th>
                            <th style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              ">
                              ADET
                            </th>
                            <th style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              ">
                              TUTAR
                            </th>
                          </tr>

                          <tr :key="indextr" v-for="(tr, indextr) in rowData">
                            <td style="padding: 8px">
                              {{ tr.STOCKNO }}
                            </td>
                            <td style="padding: 8px">
                              {{ tr.STOCKNAME }}
                            </td>
                            <td style="padding: 8px">{{ tr.PRICE }} TL</td>
                            <td style="padding: 8px">{{ tr.QUANTITY }} adet</td>
                            <td style="padding: 8px">{{ tr.TOTAL }} TL</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <br />
                  </table>
                  <br />

                  <!-- INVOICE FOOTER -->
                </vx-card>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import moment from "moment";

import "boxicons";
import Store from "../../../../store/store";
import state from "../../../../store/state";

import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
export default {
  data() {
    return {
      localeText: null,
      columnDefs: null,
      headerHeight: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        width: 125,
      },
      popupKartDetay: false,
      gelentur: "",
      satDetay: [],
      ACTNAME: "",
      PRODUCTSUM: 0.0,
      TRANSDATE: "",
      DUEDATE: "",
      DUEDAY: "",
      DISCOUNTSUM: "",
      VATSUM: "",
      TOTAL: "",
      RECEIPTNO: "",
      TRANSTYPE: "",
    };
  },
  components: {
    AgGridVue,
  },
  methods: {
    yazdir() {
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },

    kartDetay() {
      console.log(this.params.data);
      this.popupKartDetay = true;
      this.satDetay = this.params.data;
      this.ACTNAME = this.satDetay.ACTNAME;
      this.PRODUCTSUM = this.satDetay.PRODUCTSUM;
      this.TRANSDATE = this.satDetay.TRANSDATE;
      this.DUEDATE = this.satDetay.DUEDATE;
      this.DUEDAY = this.satDetay.DUEDAY;
      this.DISCOUNTSUM = this.satDetay.DISCOUNTSUM;
      this.VATSUM = this.satDetay.VATSUM;
      this.TOTAL = this.satDetay.TOTAL;
      this.RECEIPTNO = this.satDetay.RECEIPTNO;
      this.RECEIPTID = this.satDetay.RECEIPTID;
      this.TRANSTYPE = this.satDetay.TRANSTYPE; 
      let routeData = this.$router.resolve({
        name: "SatisSiparisTeklifleri", params: { Ty: this.params.data.TRANSTYPE, ActId: this.params.data.ACTID, ActName:this.params.data.ACTNAME, transDate: this.params.data.TRANSDATE
 }
      });
      window.open(routeData.href, "_blank");


    },
  },
  created() {
    this.headerHeight = 30;

    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "STOK NO",
        field: "STOCKNO",
        sortable: true,
        filter: true,
      },
      {
        headerName: "STOK ADI",
        field: "STOCKNAME",
        sortable: true,
        filter: true,
      },
      {
        headerName: "FİYAT",
        sortable: true,
        filter: true,
        field: "PRICE",
      },
      {
        headerName: "	MİKTAR",
        field: "QUANTITY",
        sortable: true,
        filter: true,
      },
      {
        headerName: "TOPLAM",
        field: "TOTAL",
        sortable: true,
        filter: true,
      },
    ];
  },
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 900px;
}
</style>